/**
 * Bottom tab bar for the end-user (client) app. Uses the .tab-bar / .tab-item
 * classes from globals.css.
 */

import { Link, useLocation } from 'react-router';
import { Home, Dumbbell, CalendarDays, MoreHorizontal } from 'lucide-react';

// Journal moved off the tab bar — it now lives in a home-page section and the
// More menu. Nutrition is reached from its Home-page link (not a tab). The
// Profile tab is labelled "More".
const athleteTabs = [
  { href: '/home', label: 'Home', icon: Home },
  { href: '/workouts', label: 'Workouts', icon: Dumbbell },
  { href: '/calendar', label: 'Calendar', icon: CalendarDays },
  { href: '/profile', label: 'More', icon: MoreHorizontal },
];

export function BottomNav() {
  const { pathname } = useLocation();
  const tabs = athleteTabs;

  return (
    <nav className="tab-bar" role="navigation" aria-label="Main navigation">
      {tabs.map((tab) => {
        const active = pathname.startsWith(tab.href);
        const Icon = tab.icon;
        return (
          <Link
            key={tab.href}
            to={tab.href}
            className={`tab-item ${active ? 'active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={22} strokeWidth={active ? 2.2 : 1.6} />
            <span>{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
